<template>
    <TemplatesEventsSingle />
</template>
